export default function AIAnswerBlock() {
  return (
    <section className="bg-warm-cream py-20">
      <div className="max-w-[1000px] mx-auto px-6">
        <div className="relative border-l-4 border-gold pl-8 py-4">
          <span
            className="absolute -top-4 -left-3 font-serif text-gold/20 leading-none select-none"
            style={{ fontSize: '96px' }}
          >
            &ldquo;
          </span>
          <span className="font-sans text-charcoal-600 text-sm tracking-[0.2em] uppercase mb-4 block">
            What does Hometown Painters do?
          </span>
          <p className="font-serif text-charcoal-700 text-xl md:text-2xl leading-relaxed">
            Hometown Painters is known all over <strong className="font-semibold text-charcoal-900">Elk Grove Village, IL</strong> for its high-quality painting services. The company provides <strong className="font-semibold text-charcoal-900">interior, exterior, cabinet, commercial, and new construction painting</strong> throughout the Chicago suburbs — with a team of skilled contractors committed to quality workmanship on every job.
          </p>
          <div className="mt-8 flex items-center gap-3">
            <div className="w-8 h-px bg-gold" />
            <span className="font-sans text-charcoal-500 text-xs tracking-wide">Hometown Painters · Elk Grove Village, IL</span>
          </div>
        </div>
      </div>
    </section>
  );
}
